import React from 'react';
import Link from 'gatsby-link';
import './_footer.scss';

const Footer = () =>
  (<footer className="page-footer">
      <nav className="footer--navigation">
        <Link className="light" to="/leistungen">Leistungen</Link>
        <Link className="light" to="/geraete">Geräte</Link>
        <Link className="light" to="/bkfp">BKFP</Link>
        <Link className="light" to="/about">Über&nbsp;uns</Link>
        <Link className="light" to="/contact">Kontakt</Link>
      </nav>
      <address>
        <p className="small">
          Römerstraße&nbsp;9&nbsp;-&nbsp;13, 6900&nbsp;Bregenz, <a href="tel:0043557453500" className="plain light">Tel.&nbsp;+43&nbsp;(0)5574&nbsp;53500,</a> Fax:&nbsp;+43&nbsp;(0)5574&nbsp;53500&nbsp;-&nbsp;4, <a href="mailto:office@radbregenz.at" className="plain light">office@radbregenz.at</a>
        </p>
      </address>
      <div className="footer-impressum">
        <small className="light">&copy; Radiologie Bregenz 2019 </small>
        <Link to="/impressum" className="plain light small">Impressum</Link>
        <Link to="/datenschutz" className="plain light small">Datenschutz</Link>
      </div>
  </footer>);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.jsx